import React, { useState } from 'react';
import Collapsible from 'react-collapsible';

export const SidebarWidget = () => {
    const [navactive, setNavactive] = useState(false);

    return (
        <>
            <div className={navactive === true ? "active w-full lg:w-1/5 frame_type lg:border-r-2 border-gray-200 min-h-screen sticky sidebar" : "w-full lg:w-1/5 frame_type lg:border-r-2 border-gray-200 min-h-screen sticky sidebar"}>
                <div className="item_nav lg:hidden" onClick={() => setNavactive((prevState) => !prevState)}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-7 h-7 inline-block">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
                    </svg>
                </div>
                <h4 className="uppercase text-sm mb-2 mt-3">FRAME TYPE</h4>
                <div className="frame_block">
                    <ul>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/FullRim-icon.png" alt="Full Frame" />
                                    <span>Full Rim</span>
                                </span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/HalfRim-icon.png" alt="Half Rim" />
                                    <span>Half Rim</span>
                                </span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/Rimless-icon.png" alt="Rimless" />
                                    <span>Rimless</span>
                                </span>
                            </label>
                        </li>
                    </ul>
                </div>

                <h4 className="uppercase text-sm mb-2 mt-5">FRAME SHAPE</h4>
                <div className="frame_block">
                    <ul>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/RoundRim-icon.png" alt="Round" />
                                    <span>Round</span>
                                </span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/RectangleRim-icon.png" alt="Rectangle" />
                                    <span>Rectangle</span>
                                </span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/SquareRim-icon.png" alt="Square" />
                                    <span>Square</span>
                                </span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/GeometricRim-icon.png" alt="Geometric" />
                                    <span>Geometric</span>
                                </span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/CatEyeRim-icon.png" alt="Cat Eye" />
                                    <span>Cat Eye</span>
                                </span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/HexagonalRim-icon.png" alt="Hexagonal" />
                                    <span>Hexagonal</span>
                                </span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/WayfarerRim-icon.png" alt="Wayfarer" />
                                    <span>Wayfarer</span>
                                </span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/AviatorRim-icon.png" alt="Aviator" />
                                    <span>Aviator</span>
                                </span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/OvalRim-icon.png" alt="Oval" />
                                    <span>Oval</span>
                                </span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/ClubmasterRim-icon.png" alt="Clubmaster" />
                                    <span>Clubmaster</span>
                                </span>
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type="checkbox" name="frame" />
                                <span>
                                    <img src="images/OctagonRim-icon.png" alt="Octagon" />
                                    <span>Octagon</span>
                                </span>
                            </label>
                        </li>
                    </ul>
                </div>

                <h4 className="uppercase text-sm mb-2 mt-5">FRAME COLOR</h4>
                <ul className="color_options">
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Black(314)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Gold(184)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Silver(127)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Brown(126)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Blue(106)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Grey(98)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Gunmetal(72)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Transparent(48)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Pink(46)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Purple(42)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Green(39)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Rose Gold(33)</span>
                            </label>
                        </div>
                    </li>

                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Tortoise(22)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Maroon(22)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Red(17)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Copper(12)</span>
                            </label>
                        </div>
                    </li>
                    <li className="list_checkbox">
                        <div className="listitem">
                            <label>
                                <input type="checkbox" name="color" />
                                <span>Orange(7)</span>
                            </label>
                        </div>
                    </li>
                </ul>
                <div className="mt-10 border-b-[1px] mb-4">
                    <Collapsible trigger="Brands">
                        <ul className="color_options mb-2">
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="brand" />
                                        <span>John Jacobs(424)</span>
                                    </label>
                                </div>
                            </li>
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="brand" />
                                        <span>Sightcart Air(381)</span>
                                    </label>
                                </div>
                            </li>
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="brand" />
                                        <span>Vincent Chase(364)</span>
                                    </label>
                                </div>
                            </li>
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="brand" />
                                        <span>Lenskart Air LA(60)</span>
                                    </label>
                                </div>
                            </li>
                        </ul>
                    </Collapsible>
                    <Collapsible trigger="Frame Size">
                        <ul className="color_options mb-2">
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="frame" />
                                        <span>Extra Narrow(34)</span>
                                    </label>
                                </div>
                            </li>
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="frame" />
                                        <span>Narrow(186)</span>
                                    </label>
                                </div>
                            </li>
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="frame" />
                                        <span>Small(3)</span>
                                    </label>
                                </div>
                            </li>
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="frame" />
                                        <span>Medium(488)</span>
                                    </label>
                                </div>
                            </li>
                        </ul>
                    </Collapsible>
                    <Collapsible trigger="Price">
                        <ul className="color_options mb-2">
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="price" />
                                        <span>$. 0 - $. 99(362)</span>
                                    </label>
                                </div>
                            </li>
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="price" />
                                        <span>$. 100 - $. 199(807)</span>
                                    </label>
                                </div>
                            </li>
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="price" />
                                        <span>$. 200 - $. 299(158)</span>
                                    </label>
                                </div>
                            </li>
                        </ul>
                    </Collapsible>
                    <Collapsible trigger="Gender">
                        <ul className="color_options mb-2">
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="gender" />
                                        <span>Unisex(1178)</span>
                                    </label>
                                </div>
                            </li>
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="gender" />
                                        <span>Women(134)</span>
                                    </label>
                                </div>
                            </li>
                            <li className="list_checkbox">
                                <div className="listitem">
                                    <label>
                                        <input type="checkbox" name="gender" />
                                        <span>Men(15)</span>
                                    </label>
                                </div>
                            </li>
                        </ul>
                    </Collapsible>

                </div>
            </div>
        </>
    )
}